import { QIcon_noconversation } from '@repo/icons/index'
import React, { useState } from 'react'
import apis from '../../../../modules/apis'
import { axiosPost } from '../../../../modules/axiosHelper'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import Pagination from '../../../common/Pagination'
import ViewAnswerItem from './ViewAnswerItem'

type PeopleOpinionsPropsType = {
  answers: any
  participantList: any
  tutorAnswerComponent: any
  handleOpenOpinion: any
}

const PeopleOpinions = ({
  answers,
  participantList,
  tutorAnswerComponent,
  handleOpenOpinion,
}: PeopleOpinionsPropsType) => {
  const isMobile = useIsMobile(undefined, 640)
  const [open, setOpen] = useState(false)

  const [myLikes, setMyLikes] = useState(
    answers.map((item, i) => {
      return {
        id: item.answer.id,
        like: !!item.my_like,
        likeCount: item.answer.like_count,
      }
    })
  )

  const myLike = (id) => {
    const likeItem = myLikes.find((item, i) => item.id === id)
    if (likeItem) {
      return likeItem.like
    } else {
      return null
    }
  }

  const getLikeCount = (id) => {
    const like = myLikes.find((item, i) => item.id === id)
    return like ? like.likeCount : 0
  }

  const handleUnlike = async (id) => {
    const response = await axiosPost(apis.lesson.unlike(), {
      answer_id: id,
    })

    if (response) {
      setMyLikes(
        myLikes.map((item, i) => {
          if (item.id === id) {
            item.like = null
            item.likeCount -= 1
          }
          return item
        })
      )
    }
  }

  const handleLike = async (id) => {
    const response = await axiosPost(apis.lesson.like(), {
      answer_id: id,
    })

    if (response.success) {
      setMyLikes(
        myLikes.map((item, i) => {
          if (item.id === id) {
            item.like = response.like
            item.likeCount += 1
          }
          return item
        })
      )
    }
  }
  const handleOpenClick = () => {
    handleOpenOpinion && handleOpenOpinion(answers)
    setOpen(!open)
  }
  const { t } = useTranslation()

  const getAnswerLength = () => {
    let answerLength = answers.length
    for (let i = 0; i < answers.length; i++) {
      if (!answers[i].answer.content) answerLength--
    }
    return answerLength
  }

  const postsPerPage = 4
  const totalPosts = answers?.length
  const [activeIndex, setActiveIndex] = useState(0)
  const handlePagination = (number) => {
    setActiveIndex(number - 1)
  }

  const startIndex = activeIndex * postsPerPage
  const endIndex = startIndex + postsPerPage
  const currentAnswers = answers.slice(startIndex, endIndex)

  return (
    <div className="mt-[20px] flex-col space-y-8 sm:mt-0">
      {currentAnswers.length > 0 &&
        currentAnswers.map(
          (item, i) =>
            item.answer.content && (
              <div key={i}>
                {!isMobile && <>{i !== 0 && <div style={{ height: 1 }} className="m-16 bg-gray-200"></div>}</>}
                <ViewAnswerItem
                  item={item}
                  isShareAnswers={true}
                  likeCounts={getLikeCount(item.answer.id)}
                  onLikeClick={
                    myLike(item.answer.id) ? (e) => handleUnlike(item.answer.id) : (e) => handleLike(item.answer.id)
                  }
                  isIconActive={myLike(item.answer.id)}
                  customClassName={isMobile ? 'border-[1px] rounded-[8px] border-gray-200 p-[16px]' : ''}
                />
              </div>
            )
        )}
      {answers.length < 1 && (
        <div className="mt-120 flex flex-col items-center justify-center space-y-20">
          <QIcon_noconversation className="h-64 w-64 text-gray-300" />
          <div className="fot-bold text-20 text-black">{t(n_lesson_prep.answer_blank_desc)}</div>
        </div>
      )}
      {tutorAnswerComponent && <div className="mt-[32px]">{tutorAnswerComponent}</div>}
      {answers.length > 4 && (
        <div className="flex flex-row items-center justify-center gap-[8px] px-[20px] pb-[20px]">
          <Pagination
            postsPerPage={postsPerPage}
            totalPosts={totalPosts}
            paginate={handlePagination}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
          />
        </div>
      )}
    </div>
  )
}

export default React.memo(PeopleOpinions)
